{
  "name": "@evmts/bundler",
  "version": "0.11.2",
  "private": false,
  "description": "Internal bundler for Evmts",
  "keywords": [
    "solidity",
    "forge",
    "foundry",
    "sol",
    "typescript",
    "web3",
    "blockchain"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/evmts/evmts-monorepo.git",
    "directory": "bundlers/bundler"
  },
  "license": "MIT",
  "contributors": [
    "Will Cory <willcory10@gmail.com>"
  ],
  "type": "module",
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "types/src/index.d.ts",
  "files": [
    "dist",
    "types",
    "src"
  ],
  "scripts": {
    "build": "nx run-many --targets=build:dist,build:types --projects=@evmts/bundler ",
    "build:dist": "tsup",
    "build:types": "tsc --emitDeclarationOnly",
    "clean": "rm -rf node_modules && rm -rf artifacts && rm -rf dist && rm -rf cache",
    "format": "rome format . --write",
    "format:check": "rome format .",
    "lint": "rome check . --apply-unsafe",
    "lint:check": "rome check . --verbose",
    "package:up": "pnpm up --latest",
    "test": "vitest --coverage",
    "test:coverage": "vitest run --coverage",
    "test:run": "vitest run",
    "test:ui": "vitest --ui"
  },
  "dependencies": {
    "@evmts/config": "workspace:^",
    "@evmts/core": "workspace:^",
    "@evmts/tsconfig": "workspace:^",
    "@types/node": "^20.5.7",
    "@types/resolve": "^1.20.2",
    "glob": "^10.3.3",
    "resolve": "^1.22.4",
    "solidity-ast": "^0.4.52",
    "unplugin": "^1.4.0"
  },
  "devDependencies": {
    "@vitest/coverage-v8": "^0.34.3",
    "@vitest/ui": "^0.34.3",
    "abitype": "^0.9.8",
    "rome": "^12.1.3",
    "solc": "0.8.21",
    "tsup": "^7.2.0",
    "typescript": "^5.2.2",
    "vitest": "^0.34.3",
    "wagmi": "^1.3.10",
    "zod": "^3.22.2"
  },
  "peerDependencies": {
    "solc": ">0.8.10"
  },
  "publishConfig": {
    "access": "public"
  }
}
